import { type ReactElement, type ReactNode } from "react"
import { useSelector, useDispatch } from "react-redux";
import { getEndUsersByDealerID } from "../../hooks/endUsers";
import { RootState } from "src/app/store";
import { useForm, SubmitHandler } from "react-hook-form";
import Modal from "src/components/Modal";
import Button from "src/components/Button";
import { apiClient } from "src/utils/Api/apiClient";
import { AppDispatch } from "src/app/store";
import { EndUserMove } from "../../types/EndUserMove";
import Saving from "src/components/Saving";

export interface EndUserEditModalProps {
        title: string,
        isOpen: boolean,
        onClose: () => void,
        endUserMove: EndUserMove,
        children?: ReactNode
}


export default function EndUserEditModal(props: EndUserEditModalProps): ReactElement {
        const { register, handleSubmit, setError, formState: { isSubmitting } } = useForm<EndUserMove>({
                defaultValues: props.endUserMove
        });
        const dispatch = useDispatch<AppDispatch>();
        const { dealers } = useSelector((state: RootState) => state.dealers);

        const onSubmit: SubmitHandler<EndUserMove> = async (data) => {
                try {
                        const response = await apiClient.post('endUser/moveEndUser', data);
                        props.onClose();
                        await dispatch(getEndUsersByDealerID(props.endUserMove.DealerId));
                } catch (dealerError: any) {
                        setError("root", {
                                message: dealerError.response.data,
                        })
                }
        }

        return <>
                <Modal isOpen={props.isOpen} modalSize="lg" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-4 flex flex-col items-center">
                                        <label className="block text-sm">Dealers</label>
                                        <select className="w-full px-3 py-2 border rounded-lg" {...register("DealerId")}>
                                                {dealers.map((dealer) => (
                                                        <option key={dealer.Id} value={dealer.Id}>{dealer.Name}</option>
                                                ))}
                                        </select>
                                </div>
                                <div className="flex gap-16 justify-around">
                                        <Button className="" size="lg" type="reset" buttonStyle="delete">Reset</Button>
                                        <Button className="" size="lg" type="submit" buttonStyle="primary">
                                                {isSubmitting ? <Saving title="Saving" color="black" /> : "Save"}
                                        </Button>
                                </div>
                        </form>
                </Modal>
        </>
}
